import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $createParagraphNode, $insertNodes, COMMAND_PRIORITY_EDITOR } from 'lexical';
import { JSX, useContext, useEffect } from 'react';
import { TableNode } from '../../nodes/TableNode';
import { $createTableNodeWithDimensions } from '../../nodes/TableNode/functions/createTableNodeWithDimensions';
import invariant from '../../shared/invariant';
import { INSERT_NEW_TABLE_COMMAND } from './commands';
import { CellContext } from './TableContext';
import { CellEditorConfig, InsertTableCommandPayload } from './types';

export function TablePlugin({
  cellEditorConfig,
  children,
}: {
  cellEditorConfig: CellEditorConfig;
  children: JSX.Element | Array<JSX.Element>;
}): JSX.Element | null {
  const [editor] = useLexicalComposerContext();
  const cellContext = useContext(CellContext);

  useEffect(() => {
    if (!editor.hasNodes([TableNode])) {
      invariant(false, 'TablePlugin: TableNode is not registered on editor');
    }

    cellContext.set(cellEditorConfig, children);

    return editor.registerCommand<InsertTableCommandPayload>(
      INSERT_NEW_TABLE_COMMAND,
      ({ columns, rows, includeHeaders }) => {
        const tableNode = $createTableNodeWithDimensions(Number(rows), Number(columns), includeHeaders);
        const parentNode = $createParagraphNode();
        parentNode.append(tableNode);
        $insertNodes([parentNode]);
        return true;
      },
      COMMAND_PRIORITY_EDITOR,
    );
  }, [cellContext, cellEditorConfig, children, editor]);

  return null;
}
